import MUTATIONTYPES from './mutation-types';
import api from '@_src/common/core/api';
import config from '@_src/common/core/config';
// import errorMap from '@_src/common/core/config/errcode';

export default {
  [MUTATIONTYPES.GET_USER_INFO] ({ commit, dispatch, state }) {
    return api.account.get_user_info().then(res => {
      if (!res.account) {
        return false;
      }

      // 如果是站点并且不是供应商的话，那就不允许访问
      if (config.hostType === 'open' && !res.vendor) {
        return Promise.reject(new Error('noAuth'));
      }
      // 如果是管理版而且不是机构，那也不给访问
      else if (config.hostType === 'open-admin' && !res.ageny) {
        return Promise.reject(new Error('noAuth'));
      }
      commit(MUTATIONTYPES.INIT_USER_CENTER, res);

      // 确认用户当前的权限
      let promise = dispatch({
        type: MUTATIONTYPES.CHECK_ROLE,
      });

      // 确定权限后，获取系统列表，用于导航展示
      return promise.then(() => {
        return dispatch({
          type: MUTATIONTYPES.GET_SYSTEM_LIST,
          data: {
            status: 2,
          },
        });
      });
    });
  },

  /**
   * 管理员身份鉴权
   * @param commit
   * @param state
   * @returns {*}
   */
  [MUTATIONTYPES.CHECK_ROLE] ({ commit, state }) {
    return api.role.get_role_by_uid_all_permit()
      .then(res => {
        // 初始化用户能看到的目录
        commit(MUTATIONTYPES.INIT_USER_MENU, res);
        return true;
      });
  },

  // [MUTATIONTYPES.INIT_USER_MENU] ({commit}) {
  //   return api.menu.get({'menu_id': 'main'}).then(res => {
  //     return commit(MUTATIONTYPES.INIT_USER_MENU, res.menu);
  //   });
  // },

  // 获取对应的app
  [MUTATIONTYPES.GET_APP] ({ commit }, obj) {
    return api.cybertron.template.get_app(obj.data).then(res => {
      commit(MUTATIONTYPES.GET_APP, res);
      return true;
    });
  },

  // 设置当前访问的应用模块
  [MUTATIONTYPES.SET_CURRENT_APP] ({ commit }, obj) {
    commit(MUTATIONTYPES.SET_CURRENT_APP, obj.data);
    return true;
  },

  // 设置一些store的变量值
  [MUTATIONTYPES.CHANGE_CURRENT_ENTRY] ({ commit }, obj) {
    commit(MUTATIONTYPES.CHANGE_CURRENT_ENTRY, obj.data);
  },

  // 初始化管理员sidebar
  [MUTATIONTYPES.INIT_MANAGE_SIDEBAR] ({ commit }, obj) {
    commit(MUTATIONTYPES.INIT_MANAGE_SIDEBAR, obj.data);
  },

  // 变更管理员sidebar，主要作用是渲染应用列表
  [MUTATIONTYPES.CHANGE_MANAGE_SIDEBAR] ({ commit }, obj) {
    commit(MUTATIONTYPES.CHANGE_MANAGE_SIDEBAR, obj.data);
  },

  // RIO
  [MUTATIONTYPES.GET_SYSTEM_LIST] ({ commit, dispatch }, obj) {
    return api.system.getSystemList(obj.data)
      .then(res => {
        let systems = res ? res.systems : [];
        commit(MUTATIONTYPES.GET_SYSTEM_LIST, systems);
        commit(MUTATIONTYPES.INIT_RENDER, true);
        if (systems) {
          commit(MUTATIONTYPES.CHANGE_ENTRY_LIST, systems);
          return systems;
        }
        else {
          return Promise.reject(new Error('无系统可操作，请添加系统后再操作'));
        }
      });
  },

  [MUTATIONTYPES.CHANGE_SYSTEM] ({ commit }, obj) {
    commit(MUTATIONTYPES.CHANGE_SYSTEM, obj.data);
  },
};
